import {
  SearchAccountsResponse,
  CursorSearch,
} from './src/loyalty-v1-account-accounts.universal';

export * from './src/loyalty-v1-account-accounts.universal.js';

/** @hidden */
export type LoyaltyAccountSearch = {};

/**
 * Retrieves a list of accounts, given the provided filters and search capabilities.
 * Search is executed on the account's name and email values.
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId LOYALTY.READ_ACCOUNTS
 * @applicableIdentity APP
 * @returns Accounts found through provided search capabilities, along with paging and aggregation data of the results.
 * @fqn com.wixpress.loyalty.account.LoyaltyAccounts.SearchAccounts
 */
export declare function searchAccounts(
  search: CursorSearch
): Promise<SearchAccountsResponse>;
